const exp1 = require('../../assets/images/whyjio/products/direct-sell-paid.png')
const exp2 = require('../../assets/images/whyjio/products/mobile-checkout.png')
const exp3 = require('../../assets/images/whyjio/products/collect.png')
const exp4 = require('../../assets/images/whyjio/products/repeat.png')
const exp5 = require('../../assets/images/whyjio/products/campaign.png')
const lpImage = require('../../assets/images/whyjio/products/jiopay-products.png')

export const sectionData = {
  header: 'JioPay products can address all the payment needs of your business',
  subHeader: '',
  lpImage: lpImage,
  data: [
    {
      header: 'Sell & Get Paid',
      subheader: 'Increase business opportunities and drive growth',
      text: 'Accept and process payments for your users via Cards, Internet Netbanking, UPI, JioPay, EMI, wallets and more. Focus on your core business and leave your payment problems with us!',
      image: exp1,
      advantage: 'Increase conversion by solving for the payment needs of your business',
      idealFor: 'Quick digital payment acceptance from users with minimal effort',
      uri: 'direct',
    },
    {
      header: 'Integrate, Personalise & Sell',
      subheader: 'Customise for relevant experience',
      text: 'Personalise the page basis your business effortlessly and increase transactions',
      image: exp2,
      advantage: 'Increasing the retention rate by offering a simple and brand- familiar payment experience.',
      idealFor: 'Simple, personalised and user- friendly payments for users.',
      uri: 'repeat',
    },
    {
      header: 'Sell, Fulfill & Collect',
      subheader: 'Initiate payment collection links on-demand',
      text: 'Enable your users to pay upon order fulfilment, be it after the completion of a ride or after the delivery of goods.',
      image: exp3,
      advantage: 'Increase customer trust by sending collection links after service fulfilment',
      idealFor: 'Remote payment collections (COD), deferred and flexible payments',
      uri: 'collect',
    },
    {
      header: 'Invoice, Collect & Repeat',
      subheader: 'Subscribe for effortless recurring payments',
      text: 'Subscribe once and get paid multiple times basis your billing cycle and user preferences',
      image: exp4,
      advantage: 'Increase lifetime value (LTV), loyalty and offer convenience by letting users pay automatically',
      idealFor: 'Cyclic, frictionless payments for your users and mitigated risks for your business',
      uri: 'campaign',
    },
    {
      header: 'Configure, Sell & Reward',
      subheader: 'Run offers relevant to your users and increase loyalty',
      text: 'Configure offers for different payment methods for specific products in your business catalogue and increase transactions.',
      image: exp5,
      advantage: 'Increase engagement rate by incentivizing users for the business they do with you.',
      idealFor: 'Automatic rewards for your users and increase in user base for your business',
      uri: 'mobile-checkout',
    },
  ],
}
